module.exports = __webpack_public_path__ + "static/img/banner-index.dd8cfe5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-index.jpg
// module id = qpnX
// module chunks = 21